import { render, staticRenderFns } from "./ProjectsUsersTable.vue?vue&type=template&id=8a6d3468"
import script from "./ProjectsUsersTable.vue?vue&type=script&lang=ts"
export * from "./ProjectsUsersTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports